export const countryName = function ($countryNames) {
  return function(code) {
    if ($countryNames.hasOwnProperty(code)) return $countryNames[code];
    return code;
  };
};

countryName.$inject = ['$countryNames'];